import gql from 'graphql-tag';

const MUTATION_REFRESH_TOKEN = gql`
  mutation refreshToken {
    refreshToken {
      isSuccess
      message
    }
  }
`;

export default MUTATION_REFRESH_TOKEN;
